import * as jsxRuntime from "/home/jenkins/agent/workspace/b2b/prd-b2b/prd-b2b-h5-public/service/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment